export default __webpack_public_path__ + "static/media/1w.c14f07f4.svg";